/**
 * New order form section accordions: panel height + chevron rotation.
 * Toggle to compare animated vs instant expand/collapse.
 */
export const ORDER_FORM_ACCORDION_ANIMATE = false

/** Duration (ms) for panel/chevron transitions when ORDER_FORM_ACCORDION_ANIMATE is true. */
export const ORDER_FORM_ACCORDION_TRANSITION_MS = 350

/**
 * Delay after toggling a section before snapping the header / running focus (matches
 * panel layout when animated). Section header snap uses `scrollIntoView` with
 * `behavior: "instant"`.
 */
export const ORDER_FORM_ACCORDION_SCROLL_DELAY_MS =
    ORDER_FORM_ACCORDION_ANIMATE ? ORDER_FORM_ACCORDION_TRANSITION_MS : 0

/**
 * Delay after focus (or section snap) before the inset `scrollBy` nudge so layout settles.
 * Used by {@link NewOrderFormPage} and Contact “Next” after customer select.
 */
export const ORDER_FORM_SCROLL_FOCUS_FOLLOW_MS = 400

/**
 * When false: no *extra* programmatic scrolling (submit scroll-to-top, contact
 * `scrollBy`, search dropdown `scrollIntoView`, optional
 * follow-up scroll after section snap). Section open still does one instant
 * `scrollIntoView` so the header sits near the top. JS-driven `.focus()` still runs.
 */
export const ORDER_FORM_PROGRAMMATIC_SCROLL_ENABLED = true
